import { Button, Input, InputOnChangeData } from "@fluentui/react-components";
import { Dismiss24Regular } from "@fluentui/react-icons";
import { ClearableInputProps } from "./types";
import { ChangeEvent, ForwardedRef, forwardRef, useCallback, useMemo } from "react";

export const ClearableInput = forwardRef((props: ClearableInputProps, ref: ForwardedRef<HTMLInputElement>) => {
	const { clearable, value, className, placeholder, contentAfter, onChange, maxLength } =
		props;

	const clearableContentAfter = useMemo<JSX.Element | undefined>(() => {
		return !!clearable && !!value ? (
			<Button
				appearance="transparent"
				icon={<Dismiss24Regular />}
				style={{ padding: 0 }}
				onClick={(event: any) => {
					event.stopPropagation();
					onChange("")
				}
				}
			/>
		) : (
			contentAfter
		);
	}, [clearable, contentAfter, value, onChange]);

	const onChangeCallback = useCallback(
		(_e: ChangeEvent<HTMLInputElement>, data: InputOnChangeData) =>
			onChange(data.value),
		[onChange]
	);

	return (
		<Input
			ref={ref}
			value={value}
			className={className}
			placeholder={placeholder}
			contentAfter={clearableContentAfter}
			onChange={onChangeCallback}
			maxLength={maxLength}
		/>
	);
});
